import { render, staticRenderFns } from "./YA_WriterContent1.vue?vue&type=template&id=2acb8928&scoped=true"
import script from "./YA_WriterContent1.vue?vue&type=script&lang=js"
export * from "./YA_WriterContent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb8928",
  null
  
)

export default component.exports